import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import {Dialog, DialogContent, DialogTitle} from "@/components/ui/dialog";
import {cn} from "@/lib/utils";
import {useState} from "react";

function CarouselThumbnail({thumbSrc, fullSrc, index}) {
  const [src, setSrc] = useState(thumbSrc || fullSrc);

  return (
    <img
      src={src}
      alt={`Report image ${index + 1}`}
      className="mx-auto h-auto max-h-36 w-full max-w-full object-contain"
      onError={() => {
        if (fullSrc && src !== fullSrc) setSrc(fullSrc);
      }}
    />
  );
}

export default function ImageCarousel({images, thumbnails, compact = false}) {
  const [expandImage, setExpandImage] = useState(null);

  return (
    <>
      <div className="w-full min-w-0 overflow-hidden print:hidden">
        <div className={compact ? "w-full min-w-0 px-2 py-2" : "w-full min-w-0 px-10"}>
          <Carousel className="w-full min-w-0">
            <CarouselContent className={compact ? "ml-0" : ""}>
              {thumbnails.map((image, index) => (
                <CarouselItem
                  key={index}
                  className={cn(
                    "mt-auto mb-auto h-fit min-w-0 cursor-pointer",
                    compact && "pl-0",
                    compact
                      ? "basis-full"
                      : "md:basis-1/2 lg:basis-1/3",
                  )}
                  onClick={() => setExpandImage(images[index])}
                >
                  <CarouselThumbnail
                    thumbSrc={image}
                    fullSrc={images[index]}
                    index={index}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            {(!compact || thumbnails.length > 1) && (
              <>
                <CarouselPrevious className={compact ? "left-1" : undefined} />
                <CarouselNext className={compact ? "right-1" : undefined} />
              </>
            )}
          </Carousel>
        </div>

        {expandImage && (
          <Dialog open onOpenChange={() => setExpandImage(null)}>
            <DialogTitle className="sr-only">ExpandedImage</DialogTitle>
            <DialogContent className="size-full !max-w-full overflow-y-auto">
              <div className="flex justify-center items-center size-full p-4">
                <img src={expandImage} alt="Expanded image" className="size-full object-contain" />
              </div>
            </DialogContent>
          </Dialog>
        )}
      </div>
      <div className="w-full print:block hidden">
        <div className="flex flex-col gap-4 w-full min-w-full">
          {images.map((url, index) => (
            <img
              key={index}
              src={url}
              className="w-full object-cover rounded-md border border-slate-300"
            />
          ))}
        </div>
      </div>
    </>
  );
}
